<template>
  <div>
    <van-tabs  v-model="tabShow"  color="#08e8de" @change="clearForm" animated >
      <van-tab title="二手房买卖合同签约">
        <van-cell-group>
          <div v-for="(item,index) in buyerList" :key="index+'buyer'" class="cell_content">
            <div class="btn_del">
              <van-cell title="买方信息" class="van-cell_titie"/>
              <van-button type="danger" v-show="index !== 0"  size="small" @click="delBuyerInfo(item.disOrder)" style="white-space: nowrap;height: 100%;">删除</van-button>
            </div>

            <van-field
                v-model.trim="item.personName"
                required
                clearable
                label="姓名"
                placeholder="请输入姓名"
                :rules="[{required: true, message: '请输入姓名'}]"
            />
            <van-field
                v-model.trim="item.certNo"
                required
                clearable
                label="身份证号"
                placeholder="请输入身份证号"
                :rules="[{required: true, message: '请输入身份证号'}]"
            />
            <van-field
                v-model.trim="item.bankCard"
                v-if="index === 0"
                required
                clearable
                label="银行卡号"
                placeholder="请输入银行卡号"
                :rules="[{required: true, message: '请输入银行卡号'}]"
            />
            <van-field
                v-model.trim="item.phoneNo"
                required
                clearable
                label="手机号"
                placeholder="请输入手机号"
                :rules="[{required: true, message: '请输入手机号'}]"
            />
          </div>
          <van-button @click="addBuyerInfo" class="add_btn">添加</van-button>
          <div v-for="(item,index) in sellerList" :key="index+'selller'" class="cell_content">
            <div class="btn_del">
              <van-cell title="卖方信息"  class="van-cell_titie"/>
              <van-button type="danger" v-show="index !== 0"  size="small" @click="delSellerInfo(item.disOrder)" style="white-space: nowrap;height: 100%;">删除</van-button>
            </div>
            <van-field
                v-model.trim="item.personName"
                required
                clearable
                label="姓名"
                placeholder="请输入姓名"
                :rules="[{required: true, message: '请输入姓名'}]"
            />
            <van-field
                v-model.trim="item.certNo"
                required
                clearable
                label="身份证号"
                placeholder="请输入身份证号"
                :rules="[{required: true, message: '请输入身份证号'}]"
            />
            <van-field
                v-model.trim="item.phoneNo"
                required
                clearable
                label="手机号"
                placeholder="请输入手机号"
                :rules="[{required: true, message: '请输入手机号'}]"
            />
          </div>
          <van-button @click="addSellerInfo" class="add_btn">添加</van-button>
          <van-cell title="产权信息"  class="van-cell_titie"/>

<!--          <van-field-->
<!--              v-model.trim="divisionName"-->
<!--              clearable-->
<!--              label="行政区划"-->
<!--              required-->
<!--              placeholder="请输入行政区划"-->
<!--          >-->
<!--          </van-field>-->
<!--          <van-cell-group id="divisionSearch" class="divisionList" v-if="searchShow">-->
<!--            <van-cell-->
<!--                v-for="item in divisionList"-->
<!--                :key="item.divisionCode"-->
<!--                :title="item.divisionName"-->
<!--                @click="divisionListClick(item)"-->
<!--                style=" float: right"-->
<!--            />-->
<!--          </van-cell-group>-->
          <van-field
              readonly
              required
              clickable
              :value="divisionName"
              label="行政区划"
              placeholder="请输入行政区划"
              input-align="center"
              @click="showpicker = true"
          />
          <van-popup v-model="showpicker" position="bottom" round get-container="#app">
            <van-picker
                show-toolbar
                :columns="divisionList"
                @confirm="onConfirm"
                value-key="divisionName"
                @cancel="showpicker = false"
            >
            </van-picker>
          </van-popup>
          <van-field label="请选择证明材料" required>
            <template #input>
              <van-radio-group v-model="proveFlag" direction="horizontal">
                <van-radio name="01">不动产权证</van-radio>
<!--                <van-radio name="02">购房合同</van-radio>-->
              </van-radio-group>
            </template>
          </van-field>
          <div v-if="proveFlag === '01'">
            <van-field
                v-model.trim="warrantNo"
                required
                clearable
                label="不动产权证号"
                placeholder="请输入不动产权证号"
                :rules="[{required: true, message: '请输入不动产权证号'}]"
            />
            <van-row>
              <van-col span="23" offset="1" class="van-cell_red" style="font-size: 14px;">材料提交须知：</van-col>
              <van-col span="23" offset="1" class="van-cell_red" style="font-size: 14px;">1、图片需清晰可读</van-col>
              <van-col span="23" offset="1" class="van-cell_red" style="font-size: 14px;">2、不动产权证：上传姓名地址整页</van-col>
            </van-row>
            <van-cell title="不动产权证" value="(请上传产权证号页)"  value-class="van-cell_value" :border="false">
            </van-cell>
            <van-cell>
              <template >
                <van-uploader  v-model="fileShowList1" :before-read="beforeRead1" :after-read="afterRead1" accept=".jpg,.jpeg,.png"
                               :before-delete="delImg1" multiple :max-count="5">
                </van-uploader>
              </template>
            </van-cell>
          </div>
<!--          <div v-else>-->
<!--            <van-field-->
<!--                v-model.trim="contractNo"-->
<!--                required-->
<!--                clearable-->
<!--                label="购房合同号"-->
<!--                placeholder="请输入购房合同号"-->
<!--                :rules="[{required: true, message: '请输入购房合同号'}]"-->
<!--            />-->
<!--            <van-cell   title="购房合同" value="(请上传合同编号页)" value-class="van-cell_value" :border="false">-->
<!--            </van-cell>-->
<!--            <van-cell>-->
<!--              <template >-->
<!--                <van-uploader  v-model="fileShowList2" :before-read="beforeRead1" :after-read="afterRead2"  accept=".jpg,.jpeg,.png"-->
<!--                               :before-delete="delImg2" multiple :max-count="5">-->
<!--                </van-uploader>-->
<!--              </template>-->
<!--            </van-cell>-->
<!--          </div>-->
        </van-cell-group>
      </van-tab>
      <van-tab title="租赁合同签约">
        <van-cell-group>
          <div v-for="(item,index) in buyerList" :key="index+'buyer'" class="cell_content">
            <div class="btn_del">
              <van-cell title="甲方信息" class="van-cell_titie"/>
              <van-button type="danger" v-show="index !== 0"  size="small" @click="delBuyerInfo(item.disOrder)" style="white-space: nowrap;height: 100%;">删除</van-button>
            </div>

            <van-field
                v-model.trim="item.personName"
                required
                clearable
                label="姓名"
                placeholder="请输入姓名"
                :rules="[{required: true, message: '请输入姓名'}]"
            />
            <van-field
                v-model.trim="item.certNo"
                required
                clearable
                label="身份证号"
                placeholder="请输入身份证号"
                :rules="[{required: true, message: '请输入身份证号'}]"
            />
            <van-field
                v-model.trim="item.phoneNo"
                required
                clearable
                label="手机号"
                placeholder="请输入手机号"
                :rules="[{required: true, message: '请输入手机号'}]"
            />
          </div>
          <van-button @click="addBuyerInfo" class="add_btn">添加</van-button>
          <div v-for="(item,index) in sellerList" :key="index+'selller'" class="cell_content">
            <div class="btn_del">
              <van-cell title="乙方信息"  class="van-cell_titie"/>
              <van-button type="danger" v-show="index !== 0"  size="small" @click="delSellerInfo(item.disOrder)" style="white-space: nowrap;height: 100%;">删除</van-button>
            </div>
            <van-field
                v-model.trim="item.personName"
                required
                clearable
                label="姓名"
                placeholder="请输入姓名"
                :rules="[{required: true, message: '请输入姓名'}]"
            />
            <van-field
                v-model.trim="item.certNo"
                required
                clearable
                label="身份证号"
                placeholder="请输入身份证号"
                :rules="[{required: true, message: '请输入身份证号'}]"
            />
            <van-field
                v-model.trim="item.phoneNo"
                required
                clearable
                label="手机号"
                placeholder="请输入手机号"
                :rules="[{required: true, message: '请输入手机号'}]"
            />
          </div>
          <van-button @click="addSellerInfo" class="add_btn">添加</van-button>
          <van-cell title="产权信息"  class="van-cell_titie"/>
<!--          <van-field-->
<!--              v-model.trim="divisionName"-->
<!--              clearable-->
<!--              label="行政区划"-->
<!--              required-->
<!--              placeholder="请输入行政区划"-->
<!--          >-->
<!--          </van-field>-->
<!--          <van-cell-group id="divisionSearch" class="divisionList" v-if="searchShow">-->
<!--            <van-cell-->
<!--                v-for="item in divisionList"-->
<!--                :key="item.divisionCode"-->
<!--                :title="item.divisionName"-->
<!--                @click="divisionListClick(item)"-->
<!--                style=" float: right"-->
<!--            />-->
<!--          </van-cell-group>-->
          <van-field
              readonly
              required
              clickable
              :value="divisionName"
              label="行政区划"
              placeholder="请输入行政区划"
              input-align="center"
              @click="showpicker = true"
          />
          <van-popup v-model="showpicker" position="bottom" round get-container="#app">
            <van-picker
                show-toolbar
                :columns="divisionList"
                @confirm="onConfirm"
                value-key="divisionName"
                @cancel="showpicker = false"
            >
            </van-picker>
          </van-popup>
          <van-field label="请选择证明材料" required>
            <template #input>
              <van-radio-group v-model="proveFlag" direction="horizontal">
                <van-radio name="01">不动产权证</van-radio>
                <van-radio name="02">购房合同</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div v-if="proveFlag === '01'">
            <van-field
                v-model.trim="warrantNo"
                required
                clearable
                label="不动产权证号"
                placeholder="请输入不动产权证号"
                :rules="[{required: true, message: '请输入不动产权证号'}]"
            />
            <van-row>
              <van-col span="23" offset="1" class="van-cell_red" style="font-size: 14px;">材料提交须知：</van-col>
              <van-col span="23" offset="1" class="van-cell_red" style="font-size: 14px;">1、图片需清晰可读，不动产权证与购房合同至少上传一种</van-col>
              <van-col span="23" offset="1" class="van-cell_red" style="font-size: 14px;">2、不动产权证：上传姓名地址整页；购房合同：上传带所够房屋地址整页和签字整页</van-col>
            </van-row>
            <van-cell title="不动产权证" value="(请上传产权证号页)"  value-class="van-cell_value" :border="false">
            </van-cell>
            <van-cell>
              <template >
                <van-uploader  v-model="fileShowList1" :before-read="beforeRead1" :after-read="afterRead1" accept=".jpg,.jpeg,.png"
                               :before-delete="delImg1" multiple :max-count="5">
                </van-uploader>
              </template>
            </van-cell>
          </div>
          <div v-else>
            <van-field
                v-model.trim="contractNo"
                required
                clearable
                label="购房合同号"
                placeholder="请输入购房合同号"
                :rules="[{required: true, message: '请输入购房合同号'}]"
            />
            <van-row>
              <van-col span="23" offset="1" class="van-cell_red" style="font-size: 14px;">材料提交须知：</van-col>
              <van-col span="23" offset="1" class="van-cell_red" style="font-size: 14px;">1、图片需清晰可读，不动产权证与购房合同至少上传一种</van-col>
              <van-col span="23" offset="1" class="van-cell_red" style="font-size: 14px;">2、不动产权证：上传姓名地址整页；购房合同：上传带所够房屋地址整页和签字整页</van-col>
            </van-row>
            <van-cell   title="购房合同" value="(请上传合同编号页)" value-class="van-cell_value" :border="false">
            </van-cell>
            <van-cell>
              <template >
                <van-uploader  v-model="fileShowList2" :before-read="beforeRead1" :after-read="afterRead2"  accept=".jpg,.jpeg,.png"
                               :before-delete="delImg2" multiple :max-count="5">
                </van-uploader>
              </template>
            </van-cell>
          </div>
        </van-cell-group>
      </van-tab>
    </van-tabs>
    <van-row type="flex" justify="center">
      <van-col span="22">
        <van-button type="primary" size="large" @click="businessSubmit" :loading="btnLoading" class="btn">提交预约</van-button>
        <button  @click="goMaps" class="my-btn">我的预约</button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import {Popup,Tabs, Tab} from 'vant'
import {submitBusiPrebookinfoApply, queryDivisionList,uploadBusiPrebookinfoFile} from '@/api/maintainFund/maintainFund'
import { Uploader } from 'vant';
export default {
  name: 'businessProcessAppoint',
  components: {
    VanUploader: Uploader,
    VanPopup: Popup,
    VanTabs: Tabs,
    VanTab: Tab,
  },
  data(){
    return {
      tabShow: 0,
      countBuyerDisOrder: 1,
      countSellerDisOrder: 1,
      btnLoading: false,
      buyerList: [{
        personName: '',
        certNo: '',
        bankCard: '',
        phoneNo: '',
        disOrder: 0
      }],
      showpicker: false,
      sellerList: [{
        personName: '',
        certNo: '',
        phoneNo: '',
        disOrder: 0
      }],
      division: {},
      divisionName:'',
      divisionCode: '',
      proveFlag: '01',
      warrantNo:'',
      contractNo: '',
      divisionList: [],
      searchShow: true,
      divisionSearchName: '',
      fileList1:[],
      fileList2:[],
      fileShowList1: [],
      fileShowList2: [],
    }
  },
  created() {
    this.fileList1 = []
    this.fileList2 = []
    this.fileShowList1 = []
    this.fileShowList2 = []
    this.fetchData()
  },
  watch: {
    // divisionName() {
    //   this.fetchData();
    // }
  },
  methods: {
    clearForm(){
      console.log("====>",this.tabShow)
      this.countBuyerDisOrder=1
      this.countSellerDisOrder=1
      this.buyerList = [{
        personName: '',
        certNo: '',
        bankCard: '',
        phoneNo: '',
        disOrder: 0
      }]
      this.sellerList= [{
        personName: '',
        certNo: '',
        phoneNo: '',
        disOrder: 0
      }]
      this.division= {}
      this.divisionName=''
      this.divisionCode= ''
      this.proveFlag= '01'
      this.warrantNo=''
      this.contractNo= ''
      // this.divisionList= []
      // this.searchShow = false
      this.divisionSearchName= ''
      this.fileList1=[]
      this.fileList2=[]
      this.fileShowList1= []
      this.fileShowList2= []
    },
    goMaps(){
      this.$router.push("/maintainFund/myAppointBusiness")
    },
     fetchData() {
      this.divisionCode = "";
      let param = {
        divisionName:  ""
      }
      queryDivisionList(param).then(response => {
        console.log(response)
        this.divisionList = response.data;
      }).catch(() => {
        this.divisionList = []
      });

      // if (this.divisionSearchName != this.divisionName){
      //   queryDivisionList(param).then(response => {
      //     this.searchShow = false;
      //     this.divisionList = response.data;
      //     this.searchShow = true;
      //   }).catch(() => {
      //     this.searchShow = false;
      //   });
      // }
    },
    onConfirm(value) {
      this.divisionName = value.divisionName;
      this.divisionCode = value.divisionCode;
      this.showpicker = false;
    },
    //判断文件类型
    beforeRead1(file) {
      if (!file.type.includes('image/')) {
        this.$dialog.alert({
          message: "请选择正确的图格式"
        }).catch()
        return false;
      }else {
        return true;
      }

    },
    //图片上传后
    afterRead1(file) {
      if (!file.file.type.includes('image/')) {
        this.$dialog.alert({
          message: "请选择正确的图格式"
        }).catch()
        return false
      }
      //存入提交数据
      this.fileList1.push(file.file)
    },
    afterRead2(file) {
      if (!file.file.type.includes('image/')) {
        this.$dialog.alert({
          message: "请选择正确的图格式"
        }).catch()
        return false
      }
      //存入提交数据
      this.fileList2.push(file.file)
    },
    //预览删除
    delImg2(file,detail) {
      this.fileShowList2.splice(detail.index, 1)
      this.fileList2.splice(detail.index, 1)
    },
    addBuyerInfo(){
      this.buyerList.push({
        personName: '',
        certNo: '',
        phoneNo: '',
        disOrder: this.countBuyerDisOrder
      })
      this.countBuyerDisOrder ++
    },
    //预览删除
    delImg1(file,detail) {
      this.fileShowList1.splice(detail.index, 1)
      this.fileList1.splice(detail.index, 1)
    },
    addSellerInfo(){
      this.sellerList.push({
        personName: '',
        certNo: '',
        phoneNo: '',
        disOrder: this.countSellerDisOrder
      })
      this.countSellerDisOrder++
    },
    //行政区划下拉列表点击
    // divisionListClick: function (division) {
    //   this.division = division;
    //   this.divisionCode = division.divisionCode;
    //   this.divisionName = division.divisionName;
    //   this.divisionSearchName = division.regionName;
    //   this.searchShow = false;
    // },
    delBuyerInfo(disOrder){
      let buyerIndex = this.buyerList.indexOf(this.buyerList.filter(item => item.disOrder === disOrder)[0])
      this.buyerList.splice(buyerIndex,1)
    },
    delSellerInfo(disOrder){
      let sellerIndex = this.sellerList.indexOf(this.sellerList.filter(item => item.disOrder === disOrder)[0])
      this.sellerList.splice(sellerIndex,1)
    },
    businessSubmit(){
      this.btnLoading = true;
      // 身份证校验
      for(let i = 0; i < this.buyerList.length; i++) {
        let mesInfo = this.isIdCardNo(this.buyerList[i].certNo,'owner')
        if( mesInfo!= 'success') {
          this.$dialog.alert({
            message: mesInfo
          }).catch()
          this.btnLoading = false;
          return false
        }
        if(!this.isPhoneNo(this.buyerList[i].phoneNo)) {
          this.$dialog.alert({
            message: "请输入正确的手机号"
          }).catch()
          this.btnLoading = false;
          return false
        }
      }
      for(let j = 0; j < this.sellerList.length; j++) {
        let mesInfo = this.isIdCardNo(this.sellerList[j].certNo,'owner')
        if( mesInfo!= 'success') {
          this.$dialog.alert({
            message: mesInfo
          }).catch()
          this.btnLoading = false;
          return false
        }
        if(!this.isPhoneNo(this.sellerList[j].phoneNo)) {
          this.$dialog.alert({
            message: "请输入正确的手机号"
          }).catch()
          this.btnLoading = false;
          return false
        }
      }
      if (this.divisionCode == null || this.divisionCode == '') {
        this.$dialog.alert({
          message: "请先选择行政区划"
        }).catch()
        this.btnLoading = false;
      }else  if (this.proveFlag === '01'&&this.fileList1.length == 0) {
        this.$dialog.alert({
          message: "请上传不动产权证"
        }).catch()
        this.btnLoading = false;
      }else  if (this.proveFlag === '02'&&this.fileList2.length == 0) {
        this.$dialog.alert({
          message: "请上传购房合同"
        }).catch()
        this.btnLoading = false;
      }else{
        let formData = new FormData();
        if (this.proveFlag === '01'&&this.fileList1) {
          this.fileList1.forEach((value) => {
            formData.append('file1', value);
          });
        }
        if(this.proveFlag === '02'&&this.fileList2){
          this.fileList2.forEach((value) => {
            formData.append('file2', value);
          });
        }
        let param = {
          buyerList:this.buyerList,
          sellerList: this.sellerList,
         divisionCode: this.divisionCode,
         proveFlag:this.proveFlag,
        warrantNo:this.warrantNo,
        contractNo: this.contractNo,
          busiType: this.tabShow === 0?'01':'02'
        };

        submitBusiPrebookinfoApply(param).then(res => {
          if (res.data.retCode === '0000') {
            formData.append("busiPrebookinfoId",res.data.retId)
            formData.append("busiType",this.proveFlag)
            uploadBusiPrebookinfoFile(formData).then(resz=>{
              if (resz.data.retCode === '0000') {
                this.$dialog.alert({
                  message: res.data.retDesc
                });
                this.clearForm();
                this.btnLoading = false;
                this.$router.push("/maintainFund/myAppointBusiness")
              }
            })
          }else{
            this.$dialog.alert({
              message: res.data.retDesc
            }).then(() => {
              this.btnLoading = false;
              return false;
            })
          }
        })

      }



    },
    isPhoneNo(phoneNumber) {
      if (phoneNumber.length !== 11) {
        return false;
      }
      var reg = /^1\d{10}$/;
      return reg.test(phoneNumber);

    },
    isIdCardNo(num,flag) {
      num = num.toUpperCase();
      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
      if (num.length !== 15 && num.length !== 18) {
        if (flag == 'owner'){
          return '身份证号长度不对';
        }else{
          return '身份证号长度不对';
        }
      }
      if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))) {
        if (flag == 'owner'){
          return '15位号码应全为数字，18位号码末位可以为数字或X。';
        }else{
          return '15位号码应全为数字，18位号码末位可以为数字或X。';
        }
      }
      // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      // 下面分别分析出生日期和校验位
      let len, re;
      len = num.length;
      if (len == 15) {
        re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
        let arrSplit = num.match(re);
        // 检查生日日期是否正确
        let dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/'
            + arrSplit[4]);
        let bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2]))
            && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3]))
            && (dtmBirth.getDate() == Number(arrSplit[4]));
        if (!bGoodDay) {
          if (flag == 'owner'){
            return '输入的身份证号里出生日期不对！';
          }else{
            return '输入的身份证号里出生日期不对！';
          }

        } else {
          // 将15位身份证转成18位
          // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
          let arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5,
              8, 4, 2);
          let arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4',
              '3', '2');
          let nTemp = 0, i;
          num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
          for (i = 0; i < 17; i++) {
            nTemp += num.substr(i, 1) * arrInt[i];
          }
          num += arrCh[nTemp % 11];
///			return num;
        }
      }
      if (len === 18) {
        re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
        let arrSplit = num.match(re);
        // 检查生日日期是否正确
        let dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/"
            + arrSplit[4]);
        let bGoodDay;
        bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2]))
            && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3]))
            && (dtmBirth.getDate() == Number(arrSplit[4]));
        if (!bGoodDay) {
          if (flag == 'owner'){
            return '输入的身份证号里出生日期不对！';
          }else{
            return '输入的身份证号里出生日期不对！';
          }
        } else {
          // 检验18位身份证的校验码是否正确。
          // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
          let valnum;
          let arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5,
              8, 4, 2);
          let arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4',
              '3', '2');
          let nTemp = 0, i;
          for (i = 0; i < 17; i++) {
            nTemp += num.substr(i, 1) * arrInt[i];
          }
          valnum = arrCh[nTemp % 11];
          if (valnum != num.substr(17, 1)) {
            if (flag == 'owner'){
              return '输入的身份证号有误！';
            }else{
              return '输入的身份证号有误！';
            }

          }
///			return num;
        }
      }
      return 'success';
    }
  }

}
</script>

<style scoped>

.add_btn {
  text-align: center;
  font-size: 14px;
  color: #04ce06;
  margin-top: 5px;
  width: 100%;
  margin-bottom: 5px;
}
.cell_content {
  margin-bottom: 5px;
}

.van-cell_titie {
  padding-left: 5px;
  margin-left: 5px;
  border-left: 5px solid #00dd02;
}
.divisionList {
  z-index: 100;
  position: absolute;
  width: 100%;
  margin-left: 25%;
  display: inline !important;
  list-style: none;
  overflow-y: scroll;
  line-height: 2;
  border-radius: 6px;
  background: white;
}
.van-cell_value {
  min-width: 70%;
  display: inline-block;
  text-align: left;
  word-break: break-all;
  font-size: 12px;
}

.btn {
  margin-bottom: 6%;
  border-radius: 5px;
  background-color: #2acba2 !important;
  border: 1px solid #2acba2 !important;
}
.btn_del {
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
  align-items: center;
}

.my-btn {
  height: 50px;
  width: 50px;
  background-color: #2acba2 !important;
  border: 1px solid #2acba2 !important;
  border-radius: 50%;
  position: fixed;
  bottom: 5%;
  right: 5%;
  font-size: 14px;
  color: #ffffff;

}
.van-cell_value {
  min-width: 70%;
  display: inline-block;
  text-align: left;
  word-break: break-all;
}
.van-cell_red {
  color: #ff0000;
}
</style>
